import { func, string, object, bool } from "prop-types"
import RegistrationContact from "components/admin/registration_contact"

const ReservationContactSection = ({
  localStorageKey,
  contact,
  onContactChange,
  isAdmin,
  isEditing,
  isClearable
}) => {
  const handleContactChange = contact => {
    onContactChange(contact)
  }

  const handleCancelClick = contact => {
    onContactChange(contact)
  }

  return (
    <RegistrationContact
      responsiblePerson={contact}
      suggestedPeople={contact ? [contact] : []}
      onSelect={handleContactChange}
      onCancelClick={handleCancelClick}
      editRegistrationContactUrl={localStorageKey}
      isAdmin={isAdmin}
      editMode={isEditing}
      isClearable={isClearable}
    />
  )
}

ReservationContactSection.propTypes = {
  localStorageKey: string.isRequired,
  onContactChange: func.isRequired,
  contact: object,
  isAdmin: bool,
  isEditing: bool,
  isClearable: bool
}

export default ReservationContactSection
